function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerRightCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 415,
    height: 287,
    viewBox: "0 0 415 287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(102 102)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFB81C",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 80.5,
    cy: 156.5,
    r: 83.5,
    opacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFB81C",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 102,
    cy: 102,
    r: 102,
    opacity: 0.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerRightCircles);
export default __webpack_public_path__ + "static/media/BannerRightCircles.50631b27.svg";
export { ForwardRef as ReactComponent };